export const TIN_HINT =
  'A Tax Identification Number (TIN) is a tax ID issued by your country of tax residence. Its name and format vary by country.';
